import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
      parentClass:null,
      modalStatus: false,
      modalMessage: '',
      loadingStatus: false,
  },
  getters:{
      registerClassName(state){
          return state.parentClass === 3?'經銷商':'會員'
      }
  },
  mutations: {
      setParentClass(state, data) {
          state.parentClass = data
      },
      setModalMessage(state, data) {
          state.modalMessage = data
          state.modalStatus = true
      },
      setModalStatus(state, data) {
          state.modalStatus = data
      },
      setLoadingStatus(state, data) {
          state.loadingStatus = data
      }
  },
  actions: {
      async getParentClass({commit, state}, req){
          commit('setParentClass',null)
          try{
              const res = await _axios.post('/api/register/start_u_code',{
                  u_code:req
              })
              commit('setParentClass',res.data.parent_class)
          }catch (e) {
              console.log(e)
              // window.location = '/'
          }
      }
  },
  modules: {
  }
})
